import { render, staticRenderFns } from "./EPA.vue?vue&type=template&id=0023e4a9&scoped=true"
import script from "./EPA.vue?vue&type=script&lang=js"
export * from "./EPA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0023e4a9",
  null
  
)

export default component.exports